import Api from '@api/live'
import { LIVE_MANAGE_PATH } from '@constant'
import { isUltimate } from '@merchant-backend/util'
import { HLJ_STATISTIC } from '@util'
import { action, observable, runInAction } from 'mobx'
import { hashHistory } from 'react-router'

class Store {
  payApi = {
    local: '/p/wedding/index.php/admin/APILiveNative/pay',
    country: '/p/wedding/index.php/admin/APILiveCountry/pay'
  }
  payParams = {
    payType: 2,
    title: '购买视频直播场次',
    returnUrl: LIVE_MANAGE_PATH
  }
  @observable info = {}
  @observable livePrice = []
  @observable liveProtocol = {}
  @observable activeTab = 'country'
  @observable field = 1
  @observable protocolModalVisible = false
  @observable confirmModalVisible = false
  @observable checkedField = {}
  @action
  getBuyInfo = async () => {
    const { success, data } = await Api.buyInfo()
    const {
      live_country_price,
      live_native_price,
      live_country_protocol,
      live_native_protocol
    } =
      data || {}
    runInAction(() => {
      if (success) {
        this.info = data
        this.livePrice =
          this.activeTab == 'country' ? live_country_price : live_native_price
        this.liveProtocol =
          this.activeTab == 'country'
            ? live_country_protocol
            : live_native_protocol
        this.checkedField = this.livePrice.filter(
          item => item.live_count == this.field
        )[0]
      }
    })

    HLJ_STATISTIC({
      element_tag: 'live_manager'
    })
  }
  @action
  changeType = e => {
    const {
      live_country_price,
      live_native_price,
      live_country_protocol,
      live_native_protocol
    } = this.info
    this.activeTab = e.target.value
    this.field = 1
    this.livePrice =
      this.activeTab == 'country' ? live_country_price : live_native_price
    this.liveProtocol =
      this.activeTab == 'country' ? live_country_protocol : live_native_protocol
    this.checkedField = this.livePrice.filter(
      item => item.live_count == this.field
    )[0]
  }

  @action
  changeField = e => {
    this.field = e.target.value
    this.checkedField = this.livePrice.filter(
      item => item.live_count == this.field
    )[0]
  }

  @action
  submit = () => {
    const { is_first, is_first_online } = this.info
    if (is_first == 1) {
      if (isUltimate()) {
        this.protocolModalVisible = true
      } else {
        this.confirmModalVisible = true
      }
    } else {
      if (is_first_online == 1) {
        this.protocolModalVisible = true
      } else {
        this.toCashier()
      }
    }

    HLJ_STATISTIC({
      element_tag: 'live_submit_order'
    })
  }

  @action
  continueOrder = () => {
    this.confirmModalVisible = false
    this.protocolModalVisible = true
  }

  @action
  cancelModal = type => () => {
    this[type] = false
  }

  @action
  agreeProtocol = () => {
    this.protocolModalVisible = false
    this.toCashier()
  }

  @action
  toCashier = () => {
    const { payParams, payApi, activeTab, checkedField } = this
    const { payType, title, returnUrl } = payParams
    const price = checkedField.show_price
    const apiName = payApi[activeTab]
    const num = checkedField.live_count
    hashHistory.push(
      `/localMerchant/cashier?payType=${payType}&price=${price}&title=${title}&apiName=${apiName}&return_url=${returnUrl}&payParams={"bnum":"${num}"}`
    )
  }
}

export default Store
